module.exports = __webpack_public_path__ + "static/img/login-back-ground_accessories.239df85b.png";